<template>
	<DialogFormDialog
		ref="dialog"
		:strings="strings"
		:max-width="540"
		@reset="reset"
	>
		<v-radio-group v-model="isAdvocate" :rules="notBlank">
			<v-radio :label="strings.roles.advocate" :value="true" />
			<v-radio :label="strings.roles.thirdParty" :value="false" />
		</v-radio-group>
		<v-autocomplete
			v-model="values.associationId"
			:items="groups"
			:search-input.sync="search"
			:rules="notBlank"
			:label="strings.accessGroup"
			:disabled="assocSelectDisabled"
			clearable
		/>
		<v-text-field
			v-model="values.firstName"
			:rules="notBlank"
			:label="strings.firstName"
			type="text"
		/>
		<v-text-field
			v-model="values.lastName"
			:rules="notBlank"
			:label="strings.lastName"
			type="text"
		/>
		<v-text-field
			v-model="values.email"
			:rules="notBlank"
			:label="strings.email"
			type="email"
		/>
		<v-text-field
			v-model="values.password"
			:rules="notBlank"
			:label="strings.password"
			type="password"
		/>
	</DialogFormDialog>
</template>

<script>
import _ from "lodash";

import strings from "@/utils/strings";

const initData = () => ({
	strings: strings.project.dialogs.createUser,

	search: null,

	values: {
		advocate: null,
		associationId: null,
		firstName: null,
		lastName: null,
		email: null,
		password: null,
	},

	notBlank: [v => !!_.trim(v).length || "Can't be blank"],
});

export default {
	data: initData,

	computed: {
		allCommunitiesAssocId() {
			const groups = this.$store.getters["accessGroups/groups"];
			const allCommunities = _.find(
				groups,
				group => group.name === "All Communities"
			);
			return _.get(allCommunities, "id");
		},

		isAdvocate: {
			get() {
				return this.values.advocate;
			},
			set(val) {
				this.values.advocate = val;
				this.values.associationId = val ? this.allCommunitiesAssocId : null;
			},
		},

		groups() {
			const groups = this.$store.getters["accessGroups/groups"];
			return _.chain(groups)
				.map(item => ({
					text: item.name,
					value: item.id,
					disabled: item.name === "All Communities",
				}))
				.sortBy("name")
				.value();
		},

		assocSelectDisabled() {
			return this.values.advocate !== false;
		},
	},

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	mounted() {
		this.pop = this.$refs.dialog.pop;
	},

	methods: {
		reset() {
			Object.assign(this, initData());
		},
	},
};
</script>
